import { useState } from "react";

const faqs = [
  {
    q: "¿Dónde queda exactamente el local?",
    a: "Dentro del Museo del Zócalo, en la Calle 29 #30-11, local 408, a pasos de la Plazoleta del Zócalo.",
  },
  {
    q: "¿Cuál es el horario?",
    a: "Todos los días, de 10:30 a. m. a 6:30 p. m.",
  },
  {
    q: "¿Puedo probar los juegos antes de comprar?",
    a: "Sí. Te explicamos las reglas y te enseñamos a jugar en el local.",
  },
  {
    q: "¿Hacen envíos a otras ciudades?",
    a: "Sí, desde iokus.co a toda Colombia, con envío gratis por compras superiores a $300.000.",
  },
  {
    q: "¿Qué medios de pago reciben?",
    a: "Efectivo y tarjetas débito y crédito.",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="preguntas" className="w-full scroll-mt-24 bg-background-100">
      <div className="mx-auto w-full max-w-3xl px-4 py-16 md:px-6 md:py-24">
        <div className="reveal mb-10 text-center md:mb-14">
          <h2 className="text-3xl font-semibold md:text-[40px]">Preguntas frecuentes</h2>
        </div>

        <div className="reveal divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={faq.q}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full min-h-[56px] items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer md:px-7"
                  >
                    <span className="text-base font-label font-semibold text-foreground-900 md:text-lg">
                      {faq.q}
                    </span>
                    <i
                      className={`ri-add-line text-xl text-accent-600 transition-transform duration-200 ${
                        isOpen ? "rotate-45" : ""
                      }`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-7 md:text-base">
                    {faq.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}